import { Controller } from "react-hook-form";
import { FormattedMessage } from "react-intl";

export default function ProfileTextField({
  control,
  name,
  labelId,
  error,
  disabled = false,
}) {
  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>
          <FormattedMessage id={labelId} />:
        </label>
      </div>
      <div className="col-lg-8">
        <div
          className={`form-label-container ${error?.message ? "mb-3" : ""}`}
        >
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <>
                <input
                  type="text"
                  {...field}
                  value={field.value ?? ""}
                  disabled={disabled}
                  className={`form-control ${
                    disabled ? "text-black-50" : error ? "is-invalid" : ""
                  }`}
                />
                <span>*</span>
              </>
            )}
          />
        </div>
        {error?.message && (
          <div role="alert" className="alert alert-danger py-1">
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
}
